<div class="payment-success-container" *ngIf="!loading && paymentData">

  <!-- Regular Payment Success -->
  <div class="payment-success-card" id="receiptPdfArea">
    <!-- Success Header -->
    <div class="success-header">
      <div class="success-icon-circle flex justify-content-center" style="background: transparent;">
        <app-lottie-animation 
          [animationPath]="'assets/animation/animation-optimized.json'"
          [width]="'100px'" 
          [height]="'100px'"
          [loop]="false">
        </app-lottie-animation>
      </div>
      <h1 class="success-title">Payment Successful!</h1>
      <p class="success-subtitle">Your order has been confirmed</p>
    </div>

    <!-- Order Information -->
    <div class="order-info-section">
      <div class="info-row">
        <div class="info-item">
          <span class="info-label">Order ID</span>
          <span class="info-value">{{ paymentData.orderId }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">Transaction ID</span>
          <span class="info-value">{{ paymentData.transactionId }}</span>
        </div>
      </div>
      <div class="info-row">
        <div class="info-item full-width">
          <span class="info-label">Payment Date</span>
          <span class="info-value">{{ paymentData.paymentDate }}</span>
        </div>
      </div>
    </div>

    <div class="divider"></div>

    <!-- Customer Details -->
    <div class="details-section">
      <div class="section-header">
        <i class="pi pi-user section-icon"></i>
        <h3 class="section-title">Customer Details</h3>
      </div>
      <div class="details-content">
        <div class="detail-item">
          <span class="detail-label">Name:</span>
          <span class="detail-value">{{ paymentData.customer.name }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Email:</span>
          <span class="detail-value">{{ paymentData.customer.email }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Phone:</span>
          <span class="detail-value">{{ paymentData.customer.phone }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Address:</span>
          <span class="detail-value">{{ paymentData.customer.address }}</span>
        </div>
      </div>
    </div>

    <div class="divider"></div>

    <!-- Package Details -->
    <div class="details-section">
      <div class="section-header">
        <i class="pi pi-box section-icon"></i>
        <h3 class="section-title">Package Details</h3>
      </div>
      <div class="package-content">
        <h4 class="package-name">{{ paymentData.package.name }}</h4>
        <p class="services-label">SERVICES INCLUDED:</p>
        <ul class="services-list">
          <li *ngFor="let service of paymentData.package.services">
            <i class="pi pi-check-circle check-icon"></i>
            <span>{{ service }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="divider"></div>

    <!-- Payment Summary -->
    <div class="details-section">
      <div class="section-header">
        <i class="pi pi-money-bill section-icon"></i>
        <h3 class="section-title">Payment Summary</h3>
      </div>
      <div class="payment-summary">
        <div class="summary-row">
          <span class="summary-label">Package Amount</span>
          <span class="summary-value">₹{{ paymentData.amount.toLocaleString('en-IN') }}</span>
        </div>
        <div class="summary-row total-row">
          <span class="summary-label total-label">Total Paid</span>
          <span class="summary-value total-value">₹{{ paymentData.amount.toLocaleString('en-IN') }}</span>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons" data-html2canvas-ignore="true">
      <p-button
        label="Download Receipt"
        icon="pi pi-download"
        (onClick)="downloadReceipt()"
        styleClass="download-btn"
      ></p-button>
      <p-button *ngIf="!isStudentPortalPackage"
        label="Make Another Payment"
        icon="pi pi-arrow-left"
        iconPos="left"
        (onClick)="makeAnotherPayment()"
        styleClass="another-payment-btn"
      ></p-button>
      <p-button *ngIf="isStudentPortalPackage"
        label="Proceed to Test"
        icon="pi pi-arrow-right"
        iconPos="right"
        (onClick)="goToTestLaunch()"
        styleClass="another-payment-btn"
      ></p-button>
    </div>
  </div>

  <!-- Footer Message -->
  <p class="confirmation-message" *ngIf="!isStudentPortalPackage && paymentData">
    A confirmation email has been sent to {{ paymentData.customer.email }}
  </p>
</div>

<!-- Loading State -->
<div class="payment-success-container" *ngIf="loading">
  <div class="payment-success-card">
    <div class="loading-state">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
      <p>Loading transaction details...</p>
    </div>
  </div>
</div>

